import Profile from '@/components/account/Profile'
import ChangePassword from '@/components/account/ChangePassword'

export default {
  name: 'account',
  path: 'account',
  redirect: '/account/profile',
  meta: {label: 'Account', auth: true},
  component: {
    render (c) { return c('router-view') }
  },
  children: [
    {
      path: 'profile',
      meta: {label: 'car', auth: true},
      component: Profile
    },
    {
      path: 'password',
      meta: {label: 'ChangePassword', auth: true},
      component: ChangePassword
    }
  ]
}
